import {
  InputProps as ChakraInputProps,
  Input as ChakraInput,
  FormControl,
  Flex,
} from '@chakra-ui/react';
import { getDateFromMillisecondsInInputNotation } from '~/common/utils/timeUtils';
import { InputField } from './InputField';
import { Text } from './Text';
import React from 'react';

type DateInputProps = ChakraInputProps & {
  label: string;
  row?: boolean;
  labelParams?: string[];
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  defaultValueMilliseconds?: number;
  useInFormik?: boolean;
  name?: string;
  w?: number | string;
  labelAlign?: string;
};

export const DateInput: React.FC<DateInputProps> = ({
  label,
  row = false,
  labelParams,
  onChange,
  defaultValueMilliseconds: defaultValue,
  useInFormik = false,
  name = 'empty',
  labelAlign = 'center',
  w = 225,
  ...props
}) => {
  return (
    <FormControl w={w}>
      <Flex direction={row ? 'row' : 'column'} align={labelAlign}>
        <Text params={labelParams} mr={row ? 2 : 0}>
          {label}
        </Text>
        {useInFormik ? (
          <InputField label="" name={name} type="date" />
        ) : (
          <ChakraInput
            type="date"
            onChange={onChange}
            // defaultValue format: YYYY-MM-DD, e.g.: 2021-06-21
            defaultValue={getDateFromMillisecondsInInputNotation(
              defaultValue as number,
            )}
            {...props}
          />
        )}
      </Flex>
    </FormControl>
  );
};
